'use client';

import { Box, Button, HStack, IconButton, Text } from '@chakra-ui/react';
import { CalendarClock, X } from 'lucide-react';

export const BACKGROUND_TASK_CREATOR_SKILL_ID = 'system:background-task-creator';

export function BackgroundTaskIntentButton({
  active,
  disabled,
  onToggle,
}: {
  active: boolean;
  disabled?: boolean;
  onToggle: () => void;
}) {
  return (
    <Button
      type="button"
      data-composer-control-trigger
      variant="plain"
      display="inline-flex"
      alignItems="center"
      gap="1.5"
      minH="26px"
      px="2"
      borderRadius="full"
      color={active ? 'accent.fg' : 'ui.text.secondary'}
      bg={active ? 'ui.surface.selected' : 'transparent'}
      cursor={disabled ? 'not-allowed' : 'pointer'}
      opacity={disabled ? 0.55 : 1}
      _hover={disabled ? {} : { bg: 'ui.surface.selected', color: 'ui.text.primary' }}
      _focusVisible={{ outline: '2px solid', outlineColor: 'accent.solid' }}
      aria-label={active ? 'Exit Schedule Agent setup' : 'Schedule an Agent'}
      title={active ? 'Exit Schedule Agent setup' : 'Schedule an Agent'}
      aria-pressed={active}
      disabled={disabled}
      onClick={onToggle}
    >
      <CalendarClock size={12} aria-hidden="true" />
      <Text
        as="span"
        data-composer-control-label
        fontSize="xs"
        fontWeight="650"
        whiteSpace="nowrap"
      >
        Schedule Agent
      </Text>
    </Button>
  );
}

export function BackgroundTaskComposerContext({ onClose }: { onClose: () => void }) {
  return (
    <HStack
      justify="space-between"
      gap="3"
      px="3.5"
      py="2.5"
      borderTopRadius="calc(var(--composer-radius, 20px) - 1px)"
      flexShrink={0}
      minW={0}
      borderBottomWidth="1px"
      borderColor="ui.border.subtle"
      bg="ui.surface.selected"
    >
      <HStack gap="2" minW={0} flex="1">
        <CalendarClock size={14} aria-hidden="true" style={{ flexShrink: 0 }} />
        <Box minW={0} flex="1">
          <Text fontSize="xs" fontWeight="750" color="ui.text.primary">
            Schedule Agent setup
          </Text>
          <Text fontSize="xs" color="ui.text.secondary" lineClamp={1}>
            Describe what should run and Attune will prepare a reviewable setup.
          </Text>
        </Box>
      </HStack>
      <IconButton
        aria-label="Exit Schedule Agent setup"
        size="xs"
        variant="ghost"
        flexShrink={0}
        onClick={onClose}
      >
        <X size={13} aria-hidden="true" />
      </IconButton>
    </HStack>
  );
}
